// src/utils/shippingLocations.js
export const getMenuItemscompaniesTurkey = (t) => [
  { id: "1", name: t("DHL") },
  { id: "2", name: t("TNT") },
  { id: "3", name: t("UPS") },
  { id: "4", name: t("Fedex") },
  { id: "5", name: t("ARAMEX") },
  { id: "6", name: t("SMSA") },
];

export const getMenuItemscompaniesEurope = (t) => [
  { id: "1", name: t("DHL") },
  { id: "2", name: t("TNT") },
  { id: "3", name: t("UPS") },
  { id: "4", name: t("Fedex") },
  { id: "5", name: t("ARAMEX") },
  { id: "6", name: t("AUSTRIAN POST") },
];
